import { Crown, ChevronDown } from "lucide-react";
import { Reveal } from "../Reveal";
import { RANK_FILTERS, SPIRITS } from "../../data/goetia";
import { scrollToId } from "../../config/site";
import { useLang } from "../../config/i18n";

export const HierarchyMap = ({ onSelect }) => {
  const { t } = useLang();
  const g = t.goetia;

  return (
  <div data-testid="hierarchy-map" className="max-w-3xl mx-auto text-center">
    <Reveal>
      <span className="inline-flex w-16 h-16 rounded-full border border-[#C5A059]/45 items-center justify-center mb-6">
        <Crown size={24} className="text-[#D9A94A]" strokeWidth={1.3} />
      </span>
      <p className="font-heading text-3xl gold-text font-light mb-1">72</p>
      <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#F7F7F8] mb-10">{g.mapCount}</p>
    </Reveal>

    <div className="flex flex-col items-center">
      <ChevronDown size={18} className="text-[#C5A059] mb-6" />
      <div className="w-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {RANK_FILTERS.filter((f) => f.id !== "todos").map((f, i) => (
          <Reveal key={f.id} delay={i * 0.06}>
            <button
              data-testid={`hierarchy-node-${f.id}`}
              onClick={() => {
                onSelect(f.id);
                scrollToId("goetia-grid");
              }}
              className="w-full h-full p-5 rounded-xl bg-[#121216] border border-[#22222B] hover:border-[#C5A059]/50 hover:-translate-y-0.5 transition-all duration-300 group"
            >
              <p className="font-heading text-2xl gold-text font-light mb-1.5">
                {SPIRITS.filter(f.match).length}
              </p>
              <p className="text-[10px] font-semibold tracking-[0.18em] uppercase text-[#D1D1DB] group-hover:text-[#C5A059] transition-colors">
                {g.filterLabels[f.id]}
              </p>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </div>
  );
};
